/**
 * Report schedule type values
 */
export enum ReportScheduleTypeEnum {
	ON_DEMAND = 'on_demand',
	SCHEDULED = 'scheduled',
	RECURRING = 'recurring',
}
